import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { SwarovskiButton } from "../../../components/_shared-components/ui-elements/SwarovskiButton";
import React from "react";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../../components/T";

export const SeeMoreLabel: ReactTFC<{ onClick: () => void; label: TranslatedValue }> = props => {
  return (
    <div
      css={css`
        text-align: center;
        margin-top: 50px;
      `}
    >
      <SwarovskiButton as={"button"} onClick={props.onClick} variant={"plain-underline"}>
        <T>{props.label}</T> 
      </SwarovskiButton>
    </div>
  );
};
